const ActionTypes = {
  ADD_GROUPS: 'ADD_GROUPS',
  SET_LAST_USED_GROUP: 'SET_LAST_USED_GROUP',
  RENAME_GROUP: 'RENAME_GROUP',
  ADD_GROUP: 'ADD_GROUP',
  DELETE_GROUP: 'DELETE_GROUP',
};

module.exports = {
  ActionTypes,
};
